<template>
    <div class="ls-message" :class="userTypeClass">
        <div class="ls-message--text-content">
            <div v-if="message.text">{{ message.text }}</div>
            <LsImage v-if="message.thumbnail_url" :src="message.thumbnail_url" />
        </div>
        <div class="ls-message--status-container" :class="statusClass">
            <div class="ls-message--user">
                <div v-show="!message.status.status" class="ls-message--icon-outline">
                    <div>!</div>
                </div>
                <LsIcon
                    v-show="message.status.status === 'blocked'"
                    type="closeoutline"
                    color="danger"
                />
                <div class="ls-message--user-text">
                    {{ message.user | fullName }}
                    <div>{{ message.status.set_at || message.created_at | timestamp }}</div>
                </div>
            </div>
            <div v-show="!message.status.status" class="ls-message--status-btns">
                <LsButton
                    track-id="ls_message-approve"
                    bg-color="success"
                    size="sm"
                    icon="checkoutline"
                    :icon-size-override="20"
                    @click="updateScheduleConversationMessage(message.id, 'approved')"
                />
                <LsButton
                    track-id="ls_message-block"
                    bg-color="danger"
                    size="sm"
                    icon="closeoutline"
                    :icon-size-override="20"
                    @click="updateScheduleConversationMessage(message.id, 'blocked')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import LsButton from '@/components/common/LsButton/LsButton.vue';
import LsImage from '@/components/common/LsImage/LsImage.vue';
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';

export default {
    name: 'LsMessage',
    components: {
        LsImage,
        LsButton,
        LsIcon,
    },
    props: {
        contractor: VueTypes.shape({
            user: VueTypes.shape({
                id: VueTypes.string,
                first_name: VueTypes.string.isRequired,
                last_name: VueTypes.string.isRequired,
            }).isRequired.loose,
        }).isRequired.loose,
        customer: VueTypes.shape({
            user: VueTypes.shape({
                id: VueTypes.string,
                first_name: VueTypes.string.isRequired,
                last_name: VueTypes.string.isRequired,
            }).isRequired.loose,
        }).isRequired.loose,
        message: VueTypes.shape({
            id: VueTypes.string.isRequired,
            user: VueTypes.shape({
                id: VueTypes.string,
                first_name: VueTypes.string.isRequired,
                last_name: VueTypes.string.isRequired,
            }).isRequired.loose,
            text: VueTypes.string,
            status: VueTypes.shape({
                status: VueTypes.oneOfType([VueTypes.string, null]),
                set_at: VueTypes.oneOfType([VueTypes.string, null]),
            }).isRequired.loose,
            thumbnail_url: VueTypes.oneOfType([VueTypes.string, null]),
            photo_url: VueTypes.oneOfType([VueTypes.string, null]),
            created_at: VueTypes.string,
        }).isRequired.loose,
        updateScheduleConversationMessage: VueTypes.func.isRequired,
    },
    computed: {
        userType() {
            const { user } = this.message;

            let userType = 'system';
            if (user.id === this.customer.user.id) {
                userType = 'customer';
            }
            if (user.id === this.contractor.user.id) {
                userType = 'contractor';
            }

            return userType;
        },
        userTypeClass() {
            return {
                'ls-message--customer': this.userType === 'customer',
                'ls-message--contractor': this.userType === 'contractor',
            };
        },
        statusClass() {
            const { status } = this.message;
            return !status.status ? '' : `ls-message--status-${status.status}`;
        },
        statusText() {
            const { status } = this.message;
            return status.status || '';
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-message {
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 80%;
    margin-bottom: 15px;

    .ls-message--contractor {
        margin-left: auto;
    }

    .ls-message--user {
        display: flex;
        flex-direction: row;
    }

    .ls-message--user-text {
        color: $secondary;
        font-size: 11px;
        font-family: $family-primary;
        margin-left: 5px;
    }

    .ls-message--text-content {
        color: $secondary-dark;
        background-color: $secondary-light;
        padding: 10px;
        font-family: $family-primary;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .ls-message--status-container {
        margin-top: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .ls-message--status-btns {
            margin-left: auto;
            button {
                display: inline-flex;
                margin-left: 10px;
                padding: 0;
                width: 36px;
                height: 36px;
            }
        }
    }
    .ls-message--icon-outline {
        background-color: $secondary-light;
        color: $secondary-dark;
        font-size: $size-5;
        font-weight: $semi-bold;
        width: 18px;
        height: 18px;
        padding: 3px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
}
.ls-message--customer {
    align-items: flex-start;
    .ls-message--text-content {
        background-color: $secondary-light;
    }
}

.ls-message--contractor {
    align-items: flex-end;
    margin-left: auto;
    .ls-message--text-content {
        background-color: $primary-light;
    }
    .ls-message--user-text {
        text-align: right;
    }
}
</style>
